import { format } from "date-fns";

export const getGraphBackgroundColor = (grade: number) => {
  switch (grade) {
    case 0:
      return "ffe0e6";
    case 1:
      return "#ffe0e6";
    case 2:
      return "#ffecb3";
    case 3:
      return "#dbf2f2";
    case 4:
      return "#d7ecfb";
  }
};

export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

export const getFeedback = (feedback: number) => {
  switch (feedback) {
    case 0:
      return "None";
    case 1:
      return "Bad";
    case 2:
      return "Fair";
    case 3:
      return "Good";
    case 4:
      return "Excellent";
  }
};

export const calculateHours = (startTime: any, endTime: any) => {
  let start: any = new Date(
    format(new Date(`2024-01-01T${startTime}:00`), "yyyy-MM-dd'T'HH:mm:ss")
  );
  let end: any = new Date(
    format(new Date(`2024-01-01T${endTime}:00`), "yyyy-MM-dd'T'HH:mm:ss")
  );

  if (end < start) {
    end.setDate(end.getDate() + 1);
  }

  const diffMs = end - start;
  const diffHours = diffMs / (1000 * 60 * 60);

  return diffHours;
};

export const colors = [
  "#444c5c",
  "#ce5a57",
  "#78a5a3",
  "#e1b16a",
  "#aaaaaa",
  "#efc070",
  "#A2C4C9",
  "#8E7CC3",
  "#D5A6BD",
  "#EA9999",
];

export const getRandomColor = () =>
  colors[Math.floor(Math.random() * colors.length)];

export const getInitials = (name?: string, surname?: string) => {
  return `${name?.[0] || ""}${surname?.[0] || ""}`.toUpperCase();
};

export const getTypeofWork = (typeofWork: any) => {
  if (typeofWork) {
    if (
      typeofWork === "Price Work" ||
      typeofWork === "X Other" ||
      typeofWork === "Labour"
    ) {
      const parts = typeofWork.split(" ");
      const firstLetter = parts[0][0];
      const secondLetter = parts[1] ? parts[1][0] : "";
      return typeofWork === "X Other"
        ? ` (X)`
        : ` (${firstLetter}${secondLetter})`;
    }
  }
};

export const getTierStatus = (tierStatus: number) => {
  switch(tierStatus) {
    case -1: return "No Tier";
    case 0: return "Active - Currently resourced on live shift";
    case 1: return "Tier 1 - Not Working / Available < 24 hours";
    case 2: return "Tier 2 - Working Available < 7 days";
    case 3: return "Tier 3 - Not looking for work currently";
    case 4: return "Tier 4 - Weekend Worker";
    case 5: return "Tier 5 - Wrong or missing contact details";
  }
}
